export default "__VITE_ASSET__TrSkmiRM__"